import LodPrdModifyView from "components/view/lod/prd/modify";

const LodPrdModifyPage = () => {
  return <LodPrdModifyView />;
};

export default LodPrdModifyPage;
